import { Component, OnInit, computed, inject, input, signal } from '@angular/core';
import { NotificationType, Reservation } from '@app/shared/interfaces';
import { GuestPortalService, VerificationData } from '@app/shared/services/guest-portal/guest-portal.service';
import { ThreadService } from '@app/shared/services/thread/thread.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  selector: 'sbnb-guest-verification-details',
  templateUrl: './guest-verification-details.component.html',
})
export class GuestVerificationDetailsComponent implements OnInit {
  reservationUuid = input<string>();
  reservation = input<Reservation>();
  verificationDetails = signal<VerificationData | null>(null);
  verificationPurposeOfStayCategoryLabel = computed(() => {
    if (
      this.verificationDetails().purpose_of_stay?.category &&
      this.verificationDetails().purpose_of_stay?.category === 'both'
    ) {
      return 'Business & pleasure';
    }

    return this.verificationDetails().purpose_of_stay?.category;
  });
  verificationPurposeOfStayExperiences = computed((): string[] => {
    const experiences = this.verificationDetails()?.purpose_of_stay?.experiences;
    if (!experiences) return [];

    // trim "Others", its useless to us
    return experiences.filter((experience) => experience !== 'others');
  });

  guestAge = computed(() => {
    const birthDate = this.verificationDetails()?.identification?.birth_date;
    if (!birthDate) return null;

    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();

    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }

    return age;
  });

  loadingData = signal(true);
  acceptingBooking = signal(false);
  rejectingBooking = signal(false);

  GuestPortalService = inject(GuestPortalService);
  ThreadService = inject(ThreadService);
  ToastService = inject(ToastNotificationsService);
  risksMetadata = this.GuestPortalService.risksMetadata;
  documentTypeMetadata = this.GuestPortalService.documentTypeMetadata;

  ngOnInit() {
    this.GuestPortalService.fetchGuestVerificationDetails(this.reservationUuid()).subscribe((details) => {
      this.verificationDetails.set(details);
      this.loadingData.set(false);
    });
  }

  acceptBooking() {
    this.acceptingBooking.set(true);
    this.ThreadService.acceptBooking(this.reservationUuid()).subscribe({
      next: () => {
        // we need to reload the reservation
        // TODO - Replace this with an update bus
        window.location.reload();
      },
      error: () => {
        this.ToastService.open('Error accepting booking', 'Dismiss', NotificationType.Error);
      },
      complete: () => {
        this.acceptingBooking.set(false);
      },
    });
  }

  rejectBooking() {
    this.rejectingBooking.set(true);
    this.ThreadService.rejectBooking(this.reservationUuid()).subscribe({
      next: () => {
        // we need to reload the reservation
        // TODO - Replace this with an update bus
        window.location.reload();
      },
      error: () => {
        this.ToastService.open('Error rejecting booking', 'Dismiss', NotificationType.Error);
      },
      complete: () => {
        this.rejectingBooking.set(false);
      },
    });
  }
}
